import { customFieldsComp as customAdminFields } from "qjumpers.common.ui";
import AddressWrapper from "../../components/commonWrapper/Address";
import { CvParsingButtonWrapper } from "../../components/commonWrapper/CvParsingButtonWrapper";
import FileUploadWrapper from "../../components/commonWrapper/FileUploadWrapper";
import LocationInputWrapper from "../../components/commonWrapper/LocationInputWrapper";
import { PhoneWrapper } from "../../components/commonWrapper/PhoneWrapper";

export const customFields = {
  address: AddressWrapper,
  cvParsingButton: CvParsingButtonWrapper,
  fileUpload: FileUploadWrapper,
  locationInput: LocationInputWrapper,
  phone: PhoneWrapper,
  ...customAdminFields,
};
